import React from 'react';

const PerpanjanganKontrak = () => {
  return (
    <h1>Perpanjangan Kontrak</h1>
  );
};

export default PerpanjanganKontrak;





